import './App.css';
import ToolBar from "./ToolBar";
import {Outlet, useNavigate} from "react-router-dom";
import Footer from "./Footer.js";
import MobileToolBar from "./MobileToolBar";
import {ButtonBase, Dialog, DialogContent} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import img_aktuelles_1 from "./images/aktuelles/Fasching2026.jpeg";
import {useState} from "react";
import Box from "@mui/material/Box";

function App() {
    const [showPopup, setShowPopup] = useState(true);
    const navigate = useNavigate();
    const [date] = useState(new Date())
    const faschingEndDate = new Date(2026, 1, 1);

    function chooseToolBar() {
        if (window.innerWidth < 720)
            return <MobileToolBar/>
        else
            return <ToolBar/>
    }

    function navigateToNews() {
        navigate("/", {state: {"scrollToNews": true}});
        setShowPopup(false);
    }

    return (
        <div className="App">
            {date < faschingEndDate &&
                <Dialog open={showPopup} onClose={() => setShowPopup(false)}>
                    <DialogContent
                        style={{
                            position: "relative",
                            backgroundColor: "white",
                            maxWidth: "90vw",  // Keep width responsive
                            maxHeight: "90vh", // Prevent it from being taller than 90% of the screen
                            overflowY: "auto", // Enables scrolling inside the dialog if content is too tall
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <IconButton
                            onClick={() => setShowPopup(false)}
                            style={{position: "absolute", top: "5px", right: "5px"}}
                        >
                            <CloseIcon/>
                        </IconButton>
                        <Box p={1}/>
                        <ButtonBase onClick={navigateToNews}
                                    style={{
                                        width: "100%",
                                        maxWidth: "500px", // Prevents it from being too wide
                                        maxHeight: "80vh", // Ensures the image doesn't exceed the viewport height
                                        height: "auto", // Keeps aspect ratio
                                        borderRadius: "8px",
                                    }}
                        >
                            <img
                                src={img_aktuelles_1}
                                alt="Vorabflyer LMT"
                                style={{
                                    width: "100%",
                                    maxWidth: "500px", // Prevents it from being too wide
                                    maxHeight: "80vh", // Ensures the image doesn't exceed the viewport height
                                    height: "auto", // Keeps aspect ratio
                                    borderRadius: "8px",
                                }}
                            />
                        </ButtonBase>
                    </DialogContent>
                </Dialog>
            }

            {chooseToolBar()}
            <div className="outlet">
                <Outlet/>
            </div>
            <Footer/>
        </div>
    );
}

export default App;
